"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ToggleButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Card = _interopRequireDefault(require("../Card/Card"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _TabFocusTrap = _interopRequireDefault(require("../TabFocusTrap/TabFocusTrap"));

var styles = {
  "Toggle": "ToggleButton__Toggle___1gUNN",
  "Toggle--active": "ToggleButton__Toggle--active___cx5OU",
  "Toggle--disabled": "ToggleButton__Toggle--disabled___2uZSk",
  "Toggle__button": "ToggleButton__Toggle__button___g0Ntb a11y__focus-outline--default___2hwb1",
  "Toggle__button__icon": "ToggleButton__Toggle__button__icon___2v22X",
  "Toggle__content-wrapper": "ToggleButton__Toggle__content-wrapper___1VoAt",
  "Toggle__button__inner-wrapper": "ToggleButton__Toggle__button__inner-wrapper___1MGKY",
  "Toggle--square": "ToggleButton__Toggle--square___3nugi"
};
var defaultProps = {
  testId: 'cf-ui-toggle-button',
  isActive: false,
  isDisabled: false
};

var ToggleButton = function ToggleButton(props) {
  var _cn;

  var className = props.className,
      icon = props.icon,
      children = props.children,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      onToggle = props.onToggle,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "icon", "children", "isActive", "isDisabled", "onToggle"]);
  var classNames = (0, _classnames["default"])(styles.Toggle, className, (_cn = {}, (0, _defineProperty2["default"])(_cn, styles['Toggle--active'], isActive), (0, _defineProperty2["default"])(_cn, styles['Toggle--disabled'], isDisabled), (0, _defineProperty2["default"])(_cn, styles['Toggle--square'], !children), _cn));

  var handleToggle = function handleToggle() {
    if (!isDisabled && onToggle) {
      onToggle();
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_Card["default"], (0, _extends2["default"])({
    className: classNames,
    padding: "none",
    selected: isActive
  }, otherProps), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: styles.Toggle__button,
    disabled: isDisabled,
    "data-test-id": "button",
    onClick: handleToggle,
    "aria-pressed": isActive
  }, /*#__PURE__*/_react["default"].createElement(_TabFocusTrap["default"], {
    className: styles['Toggle__button__inner-wrapper']
  }, icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: icon,
    color: "secondary",
    className: styles.Toggle__button__icon
  }), children && /*#__PURE__*/_react["default"].createElement("span", {
    className: styles['Toggle__content-wrapper']
  }, children))));
};

exports.ToggleButton = ToggleButton;
ToggleButton.defaultProps = defaultProps;
var _default = ToggleButton;
exports["default"] = _default;